
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './assesment.css'
import './Notfound.js'
import NotFound from './Notfound.js';


const Createperson = (props) => {    
  const navigate=useNavigate();
  
  return (
    <> 
    <div>
        <div className="confirmation-message">
          <h2>Thank You!</h2>
          <h3>  Your Assesment has been Submitted.</h3>
          <button className="confirmation-button" onClick={() => navigate('/')}>Back to Home</button>
        </div>
      
    </div>
    
    </>
  );
};

export default Createperson;
